export const PUBLICATION_LOADING_CONSTS = {
  autosaveIsDisabledMsg: 'Автосохранение отключено',
  savingMsg: 'Сохраняется...'
}
